import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleCheck } from 'lucide-react';
/**
 * 渲染单选卡片组（预计篇幅、画面比例），卡片内含图示、标题与副标题；
 * 选中卡片使用品牌描边并展示勾选图标，点击整卡即完成选择。
 */
export function ProjectOptionCards(props) {
    /** 当前选中编码，未选择时用空字符串参与比较。 */
    const selectedValue = props.value ?? '';
    return (_jsx("div", { className: "project-option-cards", role: "radiogroup", "aria-label": props.ariaLabel, children: props.options.map((option) => {
            /** 当前卡片是否为选中项。 */
            const isSelected = option.value === selectedValue;
            return (_jsxs("button", { type: "button", role: "radio", "aria-checked": isSelected, className: `project-option-card${isSelected ? ' project-option-card--selected' : ''}`, onClick: () => {
                    props.onChange?.(option.value);
                }, children: [_jsxs("span", { className: "project-option-card__head", children: [option.icon ? (_jsx("span", { className: "project-option-card__icon", "aria-hidden": "true", children: option.icon })) : null, isSelected ? (_jsx(CircleCheck, { className: "project-option-card__check", "aria-hidden": "true" })) : null] }), _jsx("span", { className: "project-option-card__label", children: option.label }), option.description ? (_jsx("span", { className: "project-option-card__description", children: option.description })) : null] }, option.value));
        }) }));
}
